import React from 'react';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    iframe: {
        minHeight: 600,
        border: `1px solid ${theme.palette.grey.A700}`,
    },
}));

const preventDefaultHandler = e => e.preventDefault();

const Iframe = props => {
    const { src, title, width = '100%', height, ...rest } = props;
    const classes = useStyles();

    return (
        <iframe
            width={width}
            allow="camera;fullscreen;accelerometer;gyroscope"
            onTouchStart={preventDefaultHandler}
            onTouchMove={preventDefaultHandler}
            {...rest}
            className={classes.iframe}
            title={title}
            src={src}
        ></iframe>
    );
};

export default Iframe;
